import URC from 'ui-react-common';
import * as types from './action-types';

const api = URC.services.coreAPIInstance;

const register = (form) => ({
    asyncAction: () => api.register(form).then((response) => {
        // Used in Google Tag Manager dataLayer
        window.dataLayer.push({
            event: 'ACCOUNT_CREATION_COMPLETE',
            loanId: response.data.loan.loanId
        });

        sessionStorage.setItem(
            'ngStorage-client',
            JSON.stringify(response.data.client)
        );
        sessionStorage.setItem(
            'ngStorage-currentLoan',
            JSON.stringify(response.data.loan)
        );
        return response;
    }),
    type: types.REGISTER,
});

export default { register };
